import React, { PureComponent } from 'react'
import { connect } from 'react-redux';

import * as actions from '../../store/actions/actions'

import './header.css'
import AdminNavbar from '../Navbars/AdminNavbar';

class Header extends PureComponent {

  onHomePageClick = () => {
    this.props.homePage()
  }

  render() {
    /*let logout = this.props.token === null ? null :
        <Grid item>
          <Logout />
        </Grid> ;
    let divider = <Divider orientation="vertical" flexItem />;*/

    return (

        <AdminNavbar />

        // <AppBar position="static" className="menu-header">
        //   <Toolbar>
        //
        //       <Grid container justify="space-between" className="blue-color" direction="row">
        //         <Grid item>
        //           <Link href="#">
        //             <img alt="" onClick={this.onHomePageClick} src={ require('./plick.png') } className="logo"/>
        //           </Link>
        //         </Grid>
        //         {/*<Divider orientation="vertical" flexItem />*/}
        //         {divider}
        //         {logout}
        //     </Grid>
        //   </Toolbar>
        // </AppBar>
    );
  }
}

const mapStateToProps = state => {
  return {
    token : state.authentication.authenticatedUser.token,
    role : state.authentication.authenticatedUser.role
  }
}
const mapDispatchToProps = dispatch => {
  return {
    userPage: () => dispatch({ type: actions.USER_PAGE_MENU_REQUEST }),
    homePage: () => dispatch({ type: actions.HOME_PAGE_MENU_REQUEST }),
    filePage: () => dispatch({ type: actions.FILE_PAGE_MENU_REQUEST }),
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Header);